export default __webpack_public_path__ + "static/media/index-mockup.bb867186.png";